import styled from '@emotion/styled'
import React, { useEffect, useState } from 'react'
import { IGenericObject, TableWithFields, TimeSeriesResponse } from '@types'
import { MainTable, StartUpFilters } from '@components'
import { Card } from '@ss/meta-core-components'
import useRest from '../../hooks/useRest'
import { generateQuery } from '@utils'
import { TimeSeriesChart } from './TimeSeriesChart'
import { EconomicTable } from './EconomicTable'
import { RPE } from './RPE'
import { Datum } from '@nivo/bullet'

/**
 * Componente pagina time series
 * @component
 */
export const TimeSeries: React.FC = () => {
  const [params, SetParams] = useState<TableWithFields>({
    filters: {},
    index: 'infocamere_time_series',
    sort_field: 'anno',
    sort_type: 'desc',
    keys: [
      { value: 'anno', type: 'string' },
      { value: 'settore', type: 'string' },
      { value: 'capitale_sociale_anno_prec', type: 'float' },
      { value: 'riserve_ba2_ba7_anno_prec', type: 'float' },
      { value: 'utile_a_nuovo_anno_prec', type: 'float' },
      { value: 'utile_perdita_anno_prec', type: 'float' },
      { value: 'valore_produzione_anno_prec', type: 'float' },
      { value: 'RR', type: 'float' },
      { value: 'RPE', type: 'float' },
      { value: 'net_profit_margin', type: 'float' },
    ],
  })

  const { post: getTSData } = useRest<TimeSeriesResponse>('/time_series')

  const [lineChartInfo, setLineChartInfo] = useState<IGenericObject>()
  const [bulletData, setBulletData] = useState<Datum[]>()
  const [tablesData, setTablesData] = useState<IGenericObject[]>([])

  const [errorMsg, setErrorMsg] = useState<string>('')

  const [yearSelected, setYearSelected] = useState<number>()

  useEffect(() => {
    if (params.filters.codice_fiscale)
      //09256270969
      getTSData({
        index: 'infocamere_time_series',
        scale_factor: 1,
        query_data: generateQuery({ params: params.filters }),
      }).then((res) => {
        setBulletData(res.bullet_data)
        setTablesData(res.boxes_data)
        setLineChartInfo(res.data)
        setErrorMsg(res.msg)
      })
  }, [params.filters])

  return (
    <StartUpFilters nameFilter={false} setParams={SetParams}>
      {params.filters.codice_fiscale &&
      params.filters.codice_fiscale.value !== '' &&
      errorMsg === '' ? (
        <>
          <MainTable selectedColumns={[]} params={params} />
          <Container>
            <TimeSeriesChart
              CI={params.filters.codice_fiscale.value}
              data={lineChartInfo?.data || undefined}
              legend={lineChartInfo?.legend || undefined}
              name={lineChartInfo?.denominazione || undefined}
              domain={{ max: lineChartInfo?.max, min: lineChartInfo?.min }}
            />
            <RPE data={bulletData} />
            <EconomicTable
              name={lineChartInfo?.denominazione || undefined}
              data={tablesData}
              type={'npm'}
            />
            <EconomicTable
              name={lineChartInfo?.denominazione || undefined}
              data={tablesData}
              type={'rr'}
            />
            {/* <ScatterPlot data={yearSelected && data[yearSelected] ? data[yearSelected] : []}/>
               {min && max ? <Slider onChange={(data) => setYearSelected(data)} min={min} max={max} step={1}/> : <></>} */}
          </Container>
        </>
      ) : (
        <Card width={'100%'}>
          <div data-cy={'alert-message'}>
            {errorMsg === ''
              ? "Per avviare l'analisi, selezionare un codice fiscale dal selettore specifico."
              : 'Errore, Controlla il codice fiscale'}
          </div>
        </Card>
      )}
    </StartUpFilters>
  )
}

//region Style
const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  align-content: space-between;
  height: 750px;
`

//endregion
